<button [attr.type]="type" (click)="onclickEvent.next()" [attr.aria-label]="value" [disabled]="disabled" mat-raised-button color="primary">
  {{ value }}
</button>
